import React, {useState} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts } from '../../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl,  Token, ImagesUrl, config, sectionID} from '../../component/include'
import Select from 'react-select'
import { longDate } from '../component/globalFunction'

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, ColumnToggle } from 'react-bootstrap-table2-toolkit';
const BirthdayUpcomings =()=> {
    const [errors, setErrors] = useState({});
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
    
    const [students, setStudents] = useState([]);
    const [birthday, setBirthday] = useState({
       duration:[],
        user:'Student'
    })
    

    const fetchStudent =()=>{
        if(sectionID !==undefined && sectionID !=='')
        if(birthday.duration.length===0){
         Alerts('Error!', 'danger', 'Please select duration')
        }else{
         setNotice({...notice, isLoading: true  });
          var sql = "select code, studentName, mobile, email, gender, classID, sectionID, passport, dateOfBirth from tbl_students where sectionID ='"+sectionID+"' and admissionStatus ='Studying' and date_format(dateOfBirth, '%m%d') >= date_format(now(), '%m%d') and date_format(dateOfBirth, '%m%d') < date_format(DATE_ADD(NOW(), INTERVAL "+birthday.duration.value+" DAY), '%m%d')"
          const fd = new FormData();
      fd.append('jwt', Token); 
          fd.append("sql", sql);
          let url = ServerUrl+'/fetchBySql_controller'
          axios.post(url, fd, config).then(result=> setStudents(result.data)
         )
         .catch((error)=>
         Alerts('Error!', 'danger', error.message)).finally(()=>{
             setNotice({...notice,  isLoading: false
             });
         }) 
       }}


const handleSelect =(option, action)=>{     
          
            setBirthday({...birthday, [action.name]:option});
            setErrors({...errors, [action.name]:''})
        }


    

const tableStudentHeader = [
    {dataField: 'passport', text: 'Picture', editable: false, formatter:(cell, row)=><img className="img-70" onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+"/students/"+row.gender+".png"}} src={ImagesUrl+'/students/'+cell} title={row.studentName}  alt={row.studentName} />},
    {dataField: 'studentName', text: 'Student Name', editable: false},
    {dataField: 'mobile', text: 'Mobile', sort: true, editable:false}, 
    {dataField: 'email',  text: 'Email',  sort: true,editable: false},
    {dataField: 'dateOfBirth', text: 'Birth Date', formatter:(cell)=>cell!=='0000-00-00'?longDate(cell):'', sort: true, editable: false}
   
 ]
 





 const TableBirthday=(props)=>{
    const { SearchBar } = Search;
    const { ToggleList } = ColumnToggle;
    //const { ExportCSVButton } = CSVExport;
    const customTotal = (from, to, size) => (
       <span >&nbsp;Showing { from } to { to } of { size } items</span>
     );
    const options = {
       showTotal: true,
     paginationTotalRenderer: customTotal,
     sizePerPageList: [{text: '7', value: 7}, {text: '15', value: 15}, {text: '20', value: 20}, {text: '50', value: 50}, {text: '100', value: 100},
     { text: 'All', value: props.data.length }]
      
     };
    return  <ToolkitProvider search columnToggle 
                keyField='ID' data={ props.data } columns={ props.columns } >
                    
                    {
                        props => (
                        <div >
                            
                <BootstrapTable 
                   { ...props.baseProps }
                   striped
               hover
               condensed
               noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
           pagination={paginationFactory(options) }
         
                            />
                        </div>
                        )
                    }
 </ToolkitProvider>
 }


        return (  
            <React.Fragment>
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Students Upcoming Birthdays">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-commenting-o"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Students</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Upcoming Birthdays</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  ">
							

	<div className="col-sm-12">

    <div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Upcoming Birthdays</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div><div className="card-block">
        <div className="card z-depth-0">
		<div className="card-block">
	
    	<div className="row">
     <section className="col-md-12">
     <div className="form-group">
                       <label > Duration</label>
                       <Select  options={[
                {value:'2', label:'Upcoming 2 Days'},
                  {value:'5', label:'Upcoming 5 Days'},
                  {value:'10', label:'Upcoming 10 Days'},
                  {value:'15', label:'Upcoming 15 Days'},
                  {value:'20', label:'Upcoming 20 Days'}
               ]} 
             onChange={handleSelect}  name="duration" value={birthday.duration}  /> 
            </div>
     
     </section> 
     
     </div><hr/>

     <div className="row"><section className="col-md-12">
     <footer className="pull-right">
	
	<button type="button" id="submit" onClick={fetchStudent} className="btn btn-primary "><i className="fa fa-search"></i> Search</button>
								</footer>
     </section>
				</div>	</div>
				
                </div></div>

</div>				
</div>

</div>
	

<div className="row  ">   <div className="col-sm-12">
                                                
<div className="card z-depth-0">
            <div className="card-header">
                <h5><i className="fa fa-th" ></i> Upcoming Birthdays</h5>
                <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                        <li><i className="feather icon-maximizes full-card"></i></li>
                        <li><i className="feather icon-minus minimize-card"></i></li>
                        <li><i className="feather icon-trash-2 close-card"></i></li>
                    </ul>
                </div>
            </div>
            <div className="card-block">     
        <div className="col-md-12 table-responsive">
        
        <TableBirthday data={students}  columns={tableStudentHeader}  />

</div>

</div>
    
    </div>
    
    </div>
    </div>




   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
</React.Fragment>
 );
        
}

export default React.memo(BirthdayUpcomings) 